export enum ViewMode {
  Editor = 0,
  History = 1,
  HistoryUO = 2,
}
